import React from 'react'
import { Link } from 'react-router-dom'

export default function BreadCrumb({ data }) {
  return (
    <>
      <ul className='dynamic-breadcrumb'>
        <li><Link to={"/"}>Home</Link></li>
        {data && data?.map((item, ind) => (
          <li key={ind}><Link to={item?.slug}>{item?.name}</Link></li>
        ))}
      </ul>
    </>
  )
}
